class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.sticky = this.querySelector('#stickyAddToCart');
    this.cartNotification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.io = null;
  }

  connectedCallback() {
    this.setMainATC();
    this.initObserver();

    subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      this.onVariantChange(e.data);
    });

    this.attachButtonListener();

    this.checkInitial(); // stato iniziale
    window.addEventListener('resize', () => this.checkInitial());
    window.addEventListener('orientationchange', () => this.checkInitial());
  }

  setMainATC() {
    const candidates = Array.from(document.querySelectorAll('button.product-form__submit[name="add"], button[type="submit"][id^="ProductSubmitButton-"]'));
    this.originalAddToCart = candidates.find(btn => !this.sticky.contains(btn)) || candidates[0] || null;
  }

  initObserver() {
    if (!this.originalAddToCart || !this.sticky) return;
    if (this.io) this.io.disconnect();
    this.io = new IntersectionObserver((entries) => {
      const inView = entries[0].isIntersecting;
      this.toggleSticky(inView);
    }, { threshold: 0 });
    this.io.observe(this.originalAddToCart);
  }

  checkInitial() {
    if (!this.originalAddToCart || !this.sticky) return;
    const r = this.originalAddToCart.getBoundingClientRect();
    const inView = r.top < window.innerHeight && r.bottom > 0;
    this.toggleSticky(inView);
  }

  toggleSticky(inView) {
    this.sticky.classList.toggle('tw-hidden', inView);
  }

  attachButtonListener() {
    this.stickyAddToCartButton = this.querySelector('.sticky-add-to-cart__submit');
    if (this.stickyAddToCartButton) {
      this.stickyAddToCartButton.addEventListener('click', this.scrollToTop.bind(this));
    }
  }

  scrollToTop() {
    setTimeout(() => {
      const cartOpen = this.cartNotification && this.cartNotification.classList.contains('active');
      if (!cartOpen) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 500);
  }

  onVariantChange(data) {
    // Update the sticky cart using section rendering
    fetch(`${this.dataset.url}?variant=${data.variant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const newSticky = doc.querySelector('#stickyAddToCart');
        if (newSticky) {
          this.sticky.innerHTML = newSticky.innerHTML;
          this.attachButtonListener();
          this.setMainATC();
          this.initObserver();
          this.checkInitial();
        }
      })
      .catch((e) => { console.error(e); });
  }

  isHeaderVisible() {
    return this.header && this.header.offsetHeight > 0 && this.header.getBoundingClientRect().top < window.innerHeight;
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
